import React from 'react'
import {
  DASHBOARD_CATEGORY_COLORS,
  DASHBOARD_CATEGORY_LABELS,
  DASHBOARD_CATEGORY_ORDER,
  type GewerkRow,
} from '../../../entities/dashboard'
import { useChartTooltip, TipRow, TipTitle } from '../model/useChartTooltip'

interface Props {
  rows: GewerkRow[]
  selected: string[]
  onToggle: (key: string) => void
}

export const GewerkBars: React.FC<Props> = ({ rows, selected, onToggle }) => {
  const { bind, tooltip } = useChartTooltip()
  const max = Math.max(1, ...rows.map((r) => r.total))

  return (
    <div>
      <ul className="mb-3.5 flex flex-wrap gap-x-4 gap-y-1.5 font-['Roboto'] text-[13px] text-gray-700">
        {DASHBOARD_CATEGORY_ORDER.map((c) => (
          <li key={c} className="inline-flex items-center gap-1.5">
            <i aria-hidden className="h-2.5 w-2.5 rounded-[3px]" style={{ background: DASHBOARD_CATEGORY_COLORS[c] }} />
            {DASHBOARD_CATEGORY_LABELS[c]}
          </li>
        ))}
      </ul>

      {rows.map((row) => {
        const dim = selected.length > 0 && !selected.includes(row.key)
        return (
          <button
            key={row.key}
            type="button"
            aria-pressed={selected.includes(row.key)}
            aria-label={`${row.name}: ${row.total} Aufträge, nach Gewerk filtern`}
            onClick={() => onToggle(row.key)}
            className={`grid h-[38px] w-full grid-cols-[96px_minmax(0,1fr)_32px] items-center gap-2 text-left sm:grid-cols-[160px_minmax(0,1fr)_40px] sm:gap-3 ${dim ? 'opacity-35' : ''}`}
            {...bind(
              <>
                <TipTitle>{row.name}</TipTitle>
                {DASHBOARD_CATEGORY_ORDER.filter((c) => row.byCategory[c] > 0).map((c) => (
                  <TipRow key={c} label={DASHBOARD_CATEGORY_LABELS[c]} value={String(row.byCategory[c])} />
                ))}
                <TipRow label="Gesamt" value={String(row.total)} />
              </>,
            )}
          >
            <span className="truncate font-['Roboto'] text-sm font-medium text-gray-800">{row.name}</span>
            <span
              aria-hidden
              className="flex h-[22px] min-w-[6px] overflow-hidden rounded-[11px]"
              style={{ width: `${(row.total / max) * 100}%` }}
            >
              {DASHBOARD_CATEGORY_ORDER.filter((c) => row.byCategory[c] > 0).map((c) => (
                <span
                  key={c}
                  className="min-w-[3px] border-r-2 border-white last:border-r-0"
                  style={{ flex: row.byCategory[c], background: DASHBOARD_CATEGORY_COLORS[c] }}
                />
              ))}
            </span>
            <span className="text-right font-['Roboto'] text-sm font-bold tabular-nums text-[#124093]">
              {row.total}
            </span>
          </button>
        )
      })}
      {tooltip}
    </div>
  )
}
